var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.item && _vm.user && ![1, _vm.user.id].includes(_vm.item.id))?_c('va-action-button',{attrs:{"item":_vm.item,"hide-label":_vm.icon,"label":_vm.$t('users.impersonate'),"icon":"mdi-lock","color":"warning","text":""},on:{"click":_vm.impersonate}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }